import { css } from '@emotion/react'
import theme from '../../../styles/theme'

// Type for radio button sizes
type RadioSize = 's' | 'm' | 'l'

const sizes = {
  s: {
    size: '1rem',
    dotSize: '0.3rem',
  },
  m: {
    size: '1.15rem',
    dotSize: '0.4rem',
  },
  l: {
    size: '1.3rem',
    dotSize: '0.5rem',
  },
}

export const standardRadioStyle = (size: RadioSize = 'l') => css`
  appearance: none;
  width: ${sizes[size].size};
  height: ${sizes[size].size};
  flex: 0 0 ${sizes[size].size};
  border: 1px solid ${theme.colors.veryVeryVeryFadedText};
  border-radius: 50%;
  background-color: ${theme.colors.surface};
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    border-color: ${theme.colors.second};
    background-color: ${theme.colors.secondLight};
  }

  &:checked {
    border: 2px solid ${theme.colors.secondHighlightDeep};
    background-color: ${theme.colors.secondLight};
    &:after {
      content: '';
      width: ${sizes[size].dotSize};
      height: ${sizes[size].dotSize};
      flex: 0 0 ${sizes[size].dotSize};
      border-radius: 50%;
      background-color: ${theme.colors.secondHighlightDeep};
    }
    &:hover {
      &:after {
        background-color: ${theme.colors.secondDark};
      }
    }
  }
`
